<template>
    <div class="RecommandationResume">
        
        <!-- Head -->
        <div class="RecommandationResume__head">
                <svg
                    v-svg
                    symbol="Economy"
                    size="0 0 143 145"
                    role="presentation"
                    class="icon--inline"
                ></svg>

                <p>
                    {{ headTitle }}
                    <span v-if="headSubTitle" class="sub-title">
                        {{ headSubTitle }}
                    </span>
                </p>
        </div>

        <div 
            v-if="headInfos" 
            class="dpe-label"
            :class="`color-${handleDpeLabelColor(mcpDpe)}`"
        >
            <svg v-svg symbol="Dpe" size="0 0 25 25" role="presentation" class="icon--inline"></svg>
            <p :inner-html.prop="headInfos"></p>
        </div>


        <!-- Content -->
        <SavingOptionsTable v-if="componentDisplayed == 'options'" :dpeLabelColor="handleDpeLabelColor(mcpDpe)"/>
        <SavingRecommendationResult v-if="componentDisplayed == 'recommendation'"/>

        <ActionsButtons 
            :displayPrimaryBtn="actionBtnPrimary"
            btnPrimaryLabel="Prendre rendez-vous"
            @primaryBtn::action="goSuccess"
            @secondBtn::action="goBack"
        />
    </div>
</template>

<script>
import SavingOptionsTable from '@/includes/Simulator/ResumePages/SavingOptionsTable.vue';
import SavingRecommendationResult from '@/includes/Simulator/ResumePages/SavingRecommendationResult.vue';
import ActionsButtons from '@/includes/Simulator/ActionsComponents/ActionsButtons.vue';
import DropdownInfos from '@/components/DropdownInfos/DropdownInfos.vue';
import { mapGetters } from "vuex";

import EventBus from "@/event-bus";


export default {
    name: "RecommandationResume",

    components: {
        ActionsButtons,
        SavingOptionsTable,
        SavingRecommendationResult,
        DropdownInfos
    },

    props: {
        currentStep: {
            type: String,
            default: 'save_energy'
        },
    },

    computed: {
        ...mapGetters({mcpDpe: "getMcpDpe"}),
    },

    data() {
        return {
            headTitle: "",
            headSubTitle: "",
            headInfo: "",
            componentDisplayed: "" ,
            actionBtnPrimary: false,
        };
    },

    methods: {
        goBack() {
            if(this.currentStep == 'save_energy' || this.currentStep == 'final_step') this.$emit('goBack::display-diagnostic');
            else this.$emit('goBack::display-tunnel')
        },

        goSuccess() {
            EventBus.$emit('gtm-recommendation_rdv::push');
            EventBus.$emit('simulator-page::exit', 'success')
        },

        /**
         * toggle component displayed deppending on step
         */
        displayComponents() {
            switch (this.currentStep) {
                case "save_energy":
                    this.headTitle = "Votre installation peut être améliorée !";
                    this.headSubTitle = "Sur la base des informations que vous nous avez fournis, voici les propositions que nous pouvons vous faire"
                    this.headInfos = `La classe énergétique actuelle estimée de votre logement est : <span>${this.mcpDpe}</span>`;
                    this.componentDisplayed = "options";
                    break;

                case "aids":
                    this.headTitle = "Notre recommandation pour faire des économies !";
                    this.componentDisplayed = "recommendation";
                    this.actionBtnPrimary = true;
                    this.$emit('stepsTab::hide');
                    EventBus.$emit('gtm-recommendation::push');
                    break;
                
                case "final_step":
                    this.headTitle = "Notre recommandation pour faire des économies !";
                    this.componentDisplayed = "recommendation";
                    this.actionBtnPrimary = true;
                    this.$emit('stepsTab::hide');
                    EventBus.$emit('gtm-recommendation::push');
                    break;
            
                default:
                    break;
            }
        },

        handleDpeLabelColor(dpeLabel) {

            const labelColor = {
                'A': 'green',
                'B': 'green',
                'C': 'orange',
                'D': 'orange',
            }

            return labelColor[dpeLabel] ? labelColor[dpeLabel] : 'red';
        } 
    },

    mounted() {
        this.displayComponents();
    },
    
}
</script>

<style lang="scss">
    .RecommandationResume { 
        color: $c-grey-dark;
        font-weight: $fw-robotoM;

        .dpe-label {
            display: none;
            margin-left: 25px;
            align-items: center;
            margin-bottom: 10px;

            p {
                margin-left: 10px;
                font-family: $font-family-text-bold;
                font-size: 1.6rem;

                span {
                    font-size: 3rem;
                    
                    font-weight: 400;
                }
            }

            &.color-green {
                p span {
                    color: $c-mcp-green;
                }
            }

            &.color-orange {
                p span {
                    color: $color-orange;
                }
            }

            &.color-red {
                p span {
                    color: $c-mib-main;
                }
            }
        }
        
        &__head {
            
            svg {
                display: none;
            }

            p {
                text-align: center;
                font-size: 2.2rem;
                padding: 0 20px;

                .sub-title {
                    display: none;
                    font-size: 1.2rem;
                    margin-top: 10px;
                    color: $c-grey-blue;
                }
                
            }
        }
    }

    .RecommandationResume {
        @include breakpoint(md) {

            .dpe-label {
                display: flex;
            }

            &__head {
                display: flex;
                align-items: center;
                gap: 5vw;
                margin-bottom: 50px;

                svg {
                    display: initial;
                }

                p {
                    flex: 1;
                    text-align: left;
                    line-height: 1;
                    font-size: 4rem;
                    padding: 0 0;

                    .sub-title {
                        display: block;
                        width: 70%;
                        font-size: 2.3rem;
                        margin-top: 20px;
                    }
                }
            }
        }
    }
</style>